import { SET_IS_AUTHORISATION_EDIT, SET_EDIT_MODE, SET_MULTI_TRANSACTIONS } from './actions';
import { RESET_APP } from '../page/actions';
import { GET_CUSTOMER_CAPABILITIES_SUCCESS } from '../limits/actions';

const defaultState = {
	hasPaymentCapability: true,
	multiTransactions: false,
	isAuthorisationEdit: false,
	editMode: false,
};

const reducer = (state = defaultState, action) => {
	switch (action.type) {
		case SET_IS_AUTHORISATION_EDIT:
			return { ...state, isAuthorisationEdit: action.isAuthorisationEdit };
		case SET_EDIT_MODE:
			return { ...state, editMode: action.editMode };
		case SET_MULTI_TRANSACTIONS:
			return { ...state, multiTransactions: action.multiTransactions };
		case RESET_APP: {
			return { ...state, isAuthorisationEdit: false, editMode: false };
		}
		case GET_CUSTOMER_CAPABILITIES_SUCCESS:
			return { ...state, user: action.payload };
		default:
			return state;
	}
};

export default reducer;
